/* eslint-disable import/prefer-default-export */
export const SETTING_PIN = 'v1/kompack/setting/pin'
export const SETTING_PROFILE = 'v1/kompack/setting/profile'
export const STORE_PIN = 'v1/kompack/setting/store/pin'
export const CONFIRM_PIN = '/auth/api/v1/user/secured/verify-pin'
export const UPDATE_PIN = '/auth/api/v1/user/setting/pin/update'
export const UPDATE_OTP_PIN = '/auth/api/v1/otp/secured/user/update-pin'
export const REQUEST_OTP_EMAIL = '/auth/api/v1/otp/request-otp/email'
export const VERIFY_OTP_EMAIL = '/auth/api/v1/otp/verify-otp'
export const SMS_OTP = 'v2/sms/otp'
export const OTP_VERIFICATION = 'v2/sms/otp/verification'
export const UPDATE_PROFILE = 'v1/kompack/setting/update/profile'
export const UPDATE_PASSWORD = '/auth/api/v1/auth/mitra/update-password'
export const WAREHOUSE_PARTNER = '/v1/kompack/warehouse/partner'
export const FORGOT_PASSWORD = '/auth/api/v1/auth/forgot-password-service'
export const CHANGE_PASSWORD = '/auth/api/v1/auth/change-password-service'
export const BANK_ACCOUNT = 'v1/kompack/setting/bank-account'
export const CHECK_BANK_ACCOUNT = 'v1/bank/check-bank-owner'
export const STORE_BANK_ACCOUNT = 'v1/kompack/setting/store/bank-account'
export const UPDATE_BANK_ACCOUNT = 'v1/kompack/setting/update/bank-account'
export const DELETE_BANK_ACCOUNT = 'v1/kompack/setting/delete/bank-account'
export const INBOUND = '/v1/kompack/inbound'
export const SELECT_PARTNERS = '/v1/kompack/inbound/select-option/partners'
export const STOCK = '/v1/kompack/warehouse/stock'
export const OUTBOUND = '/v1/kompack/outbound'
export const OUTBOUND_PARTNER = '/v1/kompack/outbound/select-option/partner'
export const MONITORING_PICKUP = 'komship/api/v1/mitra/monitoring/pickup'
export const SHIPMENTS = '/v1/kompack/shipments'
export const RAJAONGKIR_SHIPPING = '/v1/kompack/outbound/non-pickup/rajaongkir-shippings'
export const OUTBOUND_NON_PICKUP = '/v1/kompack/outbound/non-pickup'
export const CHECK_WHATSAPP = '/v1/check-wa'
export const SEND_OTP_WA = '/v1/wa/otp'
export const VERIFY_OTP_WA = '/v1/wa/otp/verification'
export const REQUEST_OTP_PHONE = '/auth/api/v1/otp/request-otp/phone'
export const CHECK_NO_MITRA = '/auth/api/v1/user/setting/phone/check-used'
export const SECURED_UPDATE_PHONE = '/auth/api/v1/otp/secured/user/update-phone'
export const DOWNLOAD_MONITORING_PICKUP = 'komship/api/v1/mitra/monitoring/pickup/export-excel'
export const PRINT_LABEL = 'v2/generate/print-label'
export const WAREHOUSE_SUBSCRIBERS = 'komship/api/v1/subscribe-warehouses/partners'
